import { type FC, type ReactNode } from 'react';
import styles from './main.scss';

const ModalError: FC<{ dataTn?: string; children: ReactNode }> = ({
    children,
    dataTn = 'modal-error',
}) => {
    return (
        <div className={styles.alert} data-tn={dataTn}>
            {children}
        </div>
    );
};

export { ModalError };
